'use client';

import { useEffect } from 'react';
import { NextSearchParams } from '@/types/general';
import CategoryFilter from './category-filter';
import ListTags from './labels-filter';
import ListWrapper from './list-wrapper';
interface Props {
  searchParams: NextSearchParams;
}
const VideoLandingContent = ({
  searchParams
}: Props) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, []);
  return <div className='flex grow gap-10' data-sentry-component="VideoLandingContent" data-sentry-source-file="content.tsx">
            <CategoryFilter mode='desktop' data-sentry-element="CategoryFilter" data-sentry-source-file="content.tsx" />

            <div className='flex flex-grow flex-col overflow-hidden'>
                <h1 className='py-1 text-body-14 font-bold lg:py-1.5 lg:text-body-16'>جعبه جادویی</h1>

                <ListTags data-sentry-element="ListTags" data-sentry-source-file="content.tsx" />

                <ListWrapper searchParams={searchParams} data-sentry-element="ListWrapper" data-sentry-source-file="content.tsx" />
            </div>
        </div>;
};
export default VideoLandingContent;